import { render } from "./ButtonConfirm.vue?vue&type=template&id=2d51493c&scoped=true"
import script from "./ButtonConfirm.vue?vue&type=script&lang=js"
export * from "./ButtonConfirm.vue?vue&type=script&lang=js"

import "./ButtonConfirm.vue?vue&type=style&index=0&id=2d51493c&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d51493c"]])

export default __exports__